/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var React = require('react');
var assign = require('react/lib/Object.assign');
var Router = require('react-router');
var DocHeader = require('./DocHeader');
var DocSearch = require('./DocSearch.js');
var TypeDocumentation = require('./TypeDocumentation');
var defs = require('../../../lib/getTypeDefs');

var $__0=      Router,Route=$__0.Route,DefaultRoute=$__0.DefaultRoute,RouteHandler=$__0.RouteHandler;

require('../../../lib/runkit-embed');

var Documentation = React.createClass({displayName: "Documentation",
  render:function() {
    return (
      React.createElement("div", null, 
        React.createElement(DocHeader, null), 
        React.createElement("div", {className: "pageBody", id: "body"}, 
          React.createElement("div", {className: "contents"}, 
            React.createElement(DocSearch, null), 
            React.createElement(RouteHandler, null)
          )
        )
      )
    );
  },
});

var DocDeterminer = React.createClass({displayName: "DocDeterminer",
  mixins: [Router.State],

  render:function() {
    var $__0=      determineDoc(this.getPath()),def=$__0.def,name=$__0.name,memberName=$__0.memberName;
    return React.createElement(TypeDocumentation, {def: def, name: name, memberName: memberName});
  },
});

function determineDoc(path) {
  var $__0=    path.split('/'),name=$__0[1],memberName=$__0[2];

  var namePath = name ? name.split('.') : [];
  var def = namePath.reduce(
    function(def, subName)  {return def && def.module && def.module[subName];},
    defs.Immutable
  );

  return { def:def, name:name, memberName:memberName };
}

module.exports = React.createClass({displayName: "exports",
  childContextTypes: {
    getPageData: React.PropTypes.func.isRequired,
  },

  getChildContext:function() {
    return {
      getPageData: this.getPageData,
    };
  },

  getPageData:function() {
    return this.pageData;
  },

  componentWillMount:function() {
    var location;
    var scrollBehavior;

    if (window.document) {
      location = Router.HashLocation;
      location.addChangeListener(function(change)  {
        this.pageData = assign({}, change, determineDoc(change.path));
      }.bind(this));

      this.pageData = !window.document
        ? {}
        : assign(
            {
              path: location.getCurrentPath(),
              type: 'init',
            },
            determineDoc(location.getCurrentPath())
          );

      scrollBehavior = {
        updateScrollPosition: function(position, actionType)  {
          switch (actionType) {
            case 'push':
              return this.getPageData().memberName
                ? null
                : window.scrollTo(0, 0);
            case 'pop':
              return window.scrollTo(
                position ? position.x : 0,
                position ? position.y : 0
              );
          }
        }.bind(this),
      };
    }

    Router.create({
      routes: (
        React.createElement(Route, {handler: Documentation, path: "/"}, 
          React.createElement(DefaultRoute, {handler: DocDeterminer}), 
          React.createElement(Route, {name: "type", path: "/:name", handler: DocDeterminer}), 
          React.createElement(Route, {
            name: "method", 
            path: "/:name/:memberName", 
            handler: DocDeterminer}
          )
        )
      ),
      location: location,
      scrollBehavior: scrollBehavior,
    }).run(function(Handler)  {
      this.setState({ handler: Handler });
      if (window.document) {
        window.document.title = (this.pageData.name + " — Immutable.js");
      }
    }.bind(this));
  },

  // TODO: replace this. this is hacky and probably wrong

  componentDidMount:function() {
    setTimeout(function()  {
      this.pageData.type = '';
    }.bind(this), 0);
  },

  componentDidUpdate:function() {
    setTimeout(function()  {
      this.pageData.type = '';
    }.bind(this), 0);
  },

  render:function() {
    var Handler = this.state.handler;
    return React.createElement(Handler, null);
  },
});
